import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AsyncFunction } from "../../functions/AsyncFunction";

// Stateの初期状態
const initialState = {
    organizer_id: "",
    email_address: "",
    // yahoo_token: "",
    business_name: "",
    business_account: "",
};

// Sliceを生成する
const slice = createSlice({
    name: "UserInfo",
    initialState,
    reducers: {
        UserInfo_initialize: (state, action) => {
            for (let key in action.payload[0]) {
                state[key] = action.payload[0][key] ? action.payload[0][key] : "";
            }
        },
        UserSet: (state, action) => {
            const name = action.payload[0];
            const value = action.payload[1];
            state[name] = value;
        },
    },
});

//会員情報更新
export const UpdateUser = function (arg) {
    const params = {
        url: "/api/UpdateUser",
        method: "put",
        params: { ...arg },
        type_name: "UpdateUser",
    };
    return AsyncFunction(params);
};

// Reducerをエクスポートする
export default slice.reducer;

// Action Creatorsをエクスポートする
export const { UserInfo_initialize, UserSet } = slice.actions;
